module.exports = __webpack_public_path__ + "static/media/new_tires_logo.2e80cafb.svg";